const noop = () => {}

export function http({ method = 'GET', headers = {}, url, body, success = noop, error = noop }) {
	const req = new XMLHttpRequest()
	if (!url) return success(null, null)

	req.addEventListener('readystatechange', () => {
		if (req.readyState !== 4) return
		if (req.status === 200) return success(req.responseText, req)
		return error(req.responseText, req)
	})

	req.open(method, url, true)
	Object.keys(headers).forEach(key => req.setRequestHeader(key, headers[key]))
	req.send(body)
}
